import MaterialReactTable from "material-react-table";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState  } from "react";
import { getProduitFour, produitDeleted } from "../../../Redux/produitReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { verification } from "../../../Redux/usersReduce";

// core components
function ListProduitFour({client}) {
  const dispatch = useDispatch();
  const t = useTranslation();
  const navigate = useHistory();
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);

  function ajouter(value) {
    navigate.puh(client+'/ajouterProduitParent/'+value.id);
  }



  function deleteProduit(id) {
    dispatch(produitDeleted({ id }));
    setTimeout(async () => {
      //notify("tr", "Suppression avec succes", "success");
      getProduit();
    }, 500);
  }

  const getProduit = useCallback(async (titre) => {
    var marche = await dispatch(getProduitFour({client}));    
    setLoader(false)
    setEntities(marche.payload);
  }, [dispatch]);


  const [columns] = React.useState([
    {
      header: "designation",
      accessorKey: "designation",
    },
    {
      header: "code",
      accessorKey: "code",
    },
    {
      header: "prix",
      accessorKey: "prix",
    },

    {
      header: "actions",
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          <Button
            onClick={() => ajouter(cell.row.values)}
            variant="info"
            size="sm"
            className="text-info btn-link edit"
          >
            Modifier parent <i className="fa fa-pincel" />
          </Button>
        </div>
      ),
    },
  ])

  function ListTable({ list, loader }) {
    return (
      <div>
        {loader ? (
          <div className="text-center">
            <img
              src={require("../../../assets/img/loader.gif")}
              alt="loader"
              className="loader-img"
            />
          </div>
        ) : (
          <MaterialReactTable
            columns={columns}
            data={list}
            enableColumnActions={true}
            enableColumnFilters={true}
            enablePagination={true}
            enableSorting={true}
            enableBottomToolbar={true}
            enableTopToolbar={true}
            muiTableBodyRowProps={{ hover: false }}
            displayColumnDefOptions={{
              'mrt-row-numbers': {
                size: 10,
              },
              'mrt-row-expand': {
                size: 10,
              },
            }}
            enableColumnFilterModes
            initialState={{
              columnVisibility: { description: false },
              density: 'compact',
              showGlobalFilter: true,
            }}
            muiSearchTextFieldProps={{
              placeholder: t("search"),
              sx: { minWidth: '18rem' },
              variant: 'outlined',
            }}
          />
        )}
      </div>
    );
  }

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);
  
  useEffect(() => {
    verifToken()
    getProduit();
  }, [getProduit]) //now shut up eslint
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("Produit.list")}</Card.Title>
              </Card.Header>
              <Card.Body>
                <ListTable list={entities} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListProduitFour;
